import clarity from '@/clarity';
import config from '@/config';
import {useUserStore} from '@/stores/apolloPlatform/user/user';

export const useClarityStore = defineStore('clarity', {
  state: () => ({
    clarityActive: false,
  }),
  actions: {
    setClarity(clarityActive: boolean) {
      this.clarityActive = clarityActive;
    },
    startClarity() {
      if (this.clarityActive === false) {
        if (!config.CLARITY_PROJECT_ID) {
          console.warn(
            'Microsoft Clarity configuration missing (CLARITY_PROJECT_ID), skipping initialization',
          );
          return;
        }

        try {
          const userEmail = useUserStore().user?.email;
          clarity(config.CLARITY_PROJECT_ID, userEmail);
          this.setClarity(true);
        } catch (error) {
          console.error('Unable to start Microsoft Clarity', error);
        }
      }
    },
  },
});
